import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "@shopify/app-bridge-react";
import { Loading, Frame, Button } from "@shopify/polaris";
import store from "store";
import axios from "axios";
import { Redirect } from "@shopify/app-bridge/actions";
import createApp from "@shopify/app-bridge";
import { InputForms } from "./Components/settings/InputForms";
import { API_ROOT } from "./constant/config";

const Dashboard = lazy(() => import("./Components/Dashboard"));
const Privacy = lazy(() => import("./Components/Privacy"));

// import Privacy from "./Components/Privacy";

const ChargeDisline = lazy(() => import("./Components/ChargeDisline"));

// const SHOPIFY_API_Key = "ce4cd8ce348e7450fe807393a83d9c28";
const SHOPIFY_API_Key = "47174d987035ea0657db25f1a891f97d";
const query = new URLSearchParams(window.location.search);
let shop = query.get("shop");
let hmac = query.get("hmac");

console.log(hmac, "hmac");
if (shop) {
  store.set("shop", shop);
}
if (hmac) {
  store.set("hmac", hmac);
}



function BaseRoute() {
  const [config,setConfig] = useState(null)
  React.useEffect(() => {
    fetchShopInfo();
  }, []);

  async function fetchShopInfo() {
    let shop = store.get("shop");

    var data = await axios.get(
      `${API_ROOT}api/v1/shopdata/?shop=${shop}`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    console.log(data.data);
    const config = {
      apiKey: SHOPIFY_API_Key,
      // shopOrigin: shop,
      host:
        process.env.NODE_ENV == "production"
          ? new URLSearchParams(window.location.search).get("host")
          : window.btoa(shop + "/admin"), //window.btoa(shop + "/admin"),
      forceRedirect: true,
    };
    setConfig(config)
    if (data.data.isCharge) {
      return;
    } else {
      console.log(shop);
   
      console.log(config, "config..........")
      const app = createApp(config);
      // redirect
      const redirect = Redirect.create(app);
      console.log(redirect, "redirect")
      // console.log(data,"data for redirect",data.data.data.confirmation_url?.split("admin")[1]);
      // window.open(  data.data.data.confirmation_url, "_self")
      // window.location.href =   data.data.data.confirmation_url
      // redirect.dispatch(
      //   Redirect.Action.REMOTE,
      //   charge_data.payload.confirmation_url
      // )
      // redirect.dispatch(
      //   Redirect.Action.ADMIN_PATH,
      //   data.data.data.confirmation_url?.split("admin")[1]
      // );

      redirect.dispatch(
        Redirect.Action.REMOTE,
        data.data.data.confirmation_url
      );
    }
  }
  return (
    config ? (
      <Provider config={config}>
        <Router>
          <Suspense
            fallback={
              <div style={{ height: "100px" }}>
                <Frame>
                  <Loading />
                </Frame>
              </div>
            }>
            <Switch>
              <Route exact path='/' component={Dashboard} />
              <Route exact path='/shopify/setting' component={InputForms} />
              <Route exact path='/shopify' component={Dashboard} />
              <Route exact path='/privacy-policy' component={Privacy} />
            </Switch>
          </Suspense>
        </Router>
      </Provider>
    ) : (
      <>Loading.....</>
    )
  );
  
}

export default BaseRoute;
